import React, {useContext} from "react";
import {useLocation, withRouter} from "react-router-dom";
import {css} from "emotion";
import {boxStyles} from "../../styles/theme";
import TitleWithBackButton from "../TitleWithBackButton";
import SelectTargetingTypeList from './SelectTargetingTypeList';
import GenericButton from "../GenericButton";
import {BuildContext} from "../../context/BuildSpotlightState";
import {GlobalContext} from "../../context/GlobalState";
import spotlights from "../../services/api/spotlights";

const TargetingBody = ({history}) => {
  const query = new URLSearchParams(useLocation().search);
  const lastLocation = query.get('lastLocation');
  const {
    name,
    type,
    headline,
    ctaText,
    ctaUrl,
    primaryColor,
    secondaryColor,
    fileName,
    fileUrl,
    pages,
    utm_source,
    utm_medium,
    utm_content,
    utm_term,
    utm_campaign,
    queryParameters,
  } = useContext(BuildContext);
  const { currentWorkspace } = useContext(GlobalContext);

  const handleAction = async (e) => {
    e.preventDefault();

    const spotlightData = {
      type,
      name,
      headline,
      ctaText,
      ctaUrl,
      fileUrl,
      fileName,
      primaryColor,
      secondaryColor,
      workspace: currentWorkspace.id,
      isActive: false,
      pages,
      utm_source,
      utm_medium,
      utm_content,
      utm_term,
      utm_campaign,
      queryParameters,
    };

    try {
      const {data} = await spotlights.create(spotlightData);
      console.log(data);
      history.push("/home");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className={container}>
      <div className="desktop">
        <TitleWithBackButton title="Advanced Options" lastLocation={lastLocation}/>
      </div>
      <form className="body" onSubmit={handleAction}>
        <SelectTargetingTypeList lastLocation={lastLocation}/>
        {lastLocation === '/build' &&
          <GenericButton text="Publish Spotlight" style="default-btn"/>
        }
      </form>
    </div>
  );
};

export default withRouter(TargetingBody);

const container = css`
  height: 100%;
  display: flex;
  flex-direction: column;
  
  .default-btn {
    width: 400px;
    max-width: 80%;
    padding-left: 24px;
    padding-right: 24px;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }
  
  .desktop {
    display: none;
  }
  
  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    .desktop {
      display: initial;
    }
    
    .default-btn {
      margin-top: 60px;
    }
  }
`;
